import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {EventService} from "../../services/event.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ChangeEventDialogComponent} from "../dialogs/change-event-dialog/change-event-dialog.component";
import { Angulartics2 } from 'angulartics2';

@Component({
  selector: 'app-switch-event',
  templateUrl: './switch-event.component.html',
  styleUrls: ['./switch-event.component.scss']
})
export class SwitchEventComponent implements OnInit {
  @Output() onSwitchEventClose: EventEmitter<any> = new EventEmitter();

  constructor(
      public eventService: EventService,
      public modalService: NgbModal,
      private angulartics2: Angulartics2) { }

  ngOnInit() {
  }

  openChangeEventModal() {
    this.modalService.open(ChangeEventDialogComponent);
  }

  onEventSelect(event) {
    this.onSwitchEventClose.emit();
    this.eventService.setEvent(event);
    this.angulartics2.eventTrack.next({
      action: 'Switch event',
      properties: {
        category: 'Header',
        label: event.label,
      }
    });
  }

}
